import React from 'react'
import { useRouter } from '@morningtrain/react-navigation'
import { getMapValue, useWillPipe } from '@morningtrain/react-helpers'
import { Env } from '@morningtrain/helpers'

function PushScheduleToHistoryOnPipe (props) {
  const router = useRouter()

  useWillPipe((payload) => {
    if (!history || typeof history.pushState !== 'function') {
      return
    }

    const scheduleId = getMapValue(payload, 'data.model.id')

    const parameters = { schedule: scheduleId }
    const route = router.currentRoute

    const url = router.route(route, parameters)

    Env.set('router.currentParameters', parameters)
    Env.set('router.currentRoute', route)
    Env.set('router.currentUrl', url)

    history.replaceState({
      route: route,
      parameters: parameters
    }, '', url)
  })

  return null
}

export default PushScheduleToHistoryOnPipe
